import { Box, Tooltip, useColorModeValue } from "@chakra-ui/react";
import moment from "moment";
import React, { useMemo } from "react";
import { BookingLocation, LocationViewModel } from "../../data/occupancy.api";

type Props = {
  startTime?: string;
  endTime?: string;
  startDate: string;
  endDate: string;
  location: BookingLocation;
  deskId: string;
  error?: boolean;
};

// milliseconds in a day
const DAY_MS = 86400000;

const BookingSchedule = ({
  startTime,
  endTime,
  startDate,
  endDate,
  location,
  deskId,
  error,
}: Props) => {
  const bg = useColorModeValue("blackAlpha.200", "whiteAlpha.200");
  const fg = useColorModeValue("lancsBlue.500", "lancsBlue.300");
  const fgHighlight = useColorModeValue("lancsRed.500", "lancsRed.300");
  const fgOk = useColorModeValue("green.500", "green.300");
  const nowLine = useColorModeValue("blackAlpha.600", "whiteAlpha.600");

  const slots = useMemo(() => {
    return (
      location.bookedEntitys.find((entity) => entity.id === deskId)
        ?.timeslots ?? []
    );
  }, [location, deskId]);

  const startIso = useMemo(() => {
    return moment(
      startDate + " " + startTime,
      "YYYY-MM-DD HH:mm"
    ).toISOString();
  }, [startTime, startDate]);

  const endIso = useMemo(() => {
    return moment(endDate + " " + endTime, "YYYY-MM-DD HH:mm").toISOString();
  }, [endTime, endDate]);

  const numDays = useMemo(() => {
    return moment(endDate).diff(moment(startDate), "days") + 1;
  }, [startDate, endDate]);

  return (
    <Box overflowX="auto" position="relative" bg={bg} h={10} rounded="md">
      {startTime && endTime && startDate && endDate ? (
        <Box
          bg={error ? fgHighlight : fgOk}
          opacity={0.6}
          top="50%"
          transform="translateY(-50%)"
          h={7}
          position="absolute"
          rounded="sm"
          left={
            (moment(startIso).diff(moment(startIso).startOf("day")) * 100) /
              DAY_MS /
              numDays +
            "%"
          }
          w={
            (moment(endIso).diff(startIso) * 100) / DAY_MS / numDays + "%"
          }></Box>
      ) : null}
      {slots.map((slot) => (
        <Tooltip
          label={`${slot.bookee ? slot.bookee : "Private booking"} (${moment(
            slot.from
          ).format("HH:mm")} - ${moment(slot.to).format("HH:mm")})`}>
          <Box
            bg={fg}
            top="50%"
            opacity={0.6}
            transform="translateY(-50%)"
            h={7}
            position="absolute"
            rounded="sm"
            left={
              (moment(slot.from).diff(moment(startDate).startOf("day")) * 100) /
                DAY_MS /
                numDays +
              "%"
            }
            w={
              (moment(slot.to).diff(slot.from) * 100) / DAY_MS / numDays + "%"
            }></Box>
        </Tooltip>
      ))}

      {moment(startDate, "YYYY-MM-DD").isSame(moment(), "day") ? (
        <Box
          bg={nowLine}
          top={0}
          h="100%"
          position="absolute"
          w={1}
          left={
            (moment().diff(moment().startOf("day")) * 100) / DAY_MS / numDays +
            "%"
          }></Box>
      ) : null}
    </Box>
  );
};

export default BookingSchedule;
